import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const ContentCreation = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="64" viewBox="0 0 94 64" width="94" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M81.78 9.9H16.72a5.95 5.95 0 0 0-5.95 5.95v37.66a5.95 5.95 0 0 0 5.95 5.95h65.06a5.95 5.95 0 0 0 5.95-5.95V15.85a5.95 5.95 0 0 0-5.95-5.95Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M81 3.97H7.67c-1 0-1.8.8-1.8 1.8v45.95c0 1 .8 1.8 1.8 1.8H81c1 0 1.8-.8 1.8-1.8V5.77c0-1-.8-1.8-1.8-1.8Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M61.5 10.1H19.26c-1 0-1.8.8-1.8 1.8v33.67c0 1 .8 1.8 1.8 1.8H61.5c1 0 1.8-.8 1.8-1.8V11.9c0-1-.8-1.8-1.8-1.8Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M69.73 38.21h5.92c.71 0 1.29-.57 1.29-1.29V20.56a1.3 1.3 0 0 0-1.29-1.29h-5.92a1.3 1.3 0 0 0-1.29 1.29v16.36c0 .72.58 1.3 1.29 1.3Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M11.59 20.95v15.58" strokeWidth={strokeWidth} />
      <path d="M49.6 23.25v12.3h-6.14V29.4H37.3v6.14h-6.14V23.25z" fill={shades.black} />
    </svg>
  );
};
